import { purchaseGroup } from './purchaseGroup';
import { profileGroup } from './profileGroup';
import { ticketGroup } from './ticketGroup';
import { giftCardBalanceGroup } from './giftCardBalanceGroup';
import { clubsGroup } from './clubsGroup';
import { pointsGroup } from './pointsGroup';
import { contactUsGroup } from './contactUsGroup';
import { payCardGroup } from './payCardGroup';
import { returnsGroup } from './returnsGroup';
import { exchangeLatamMilesGroup } from './exchangeLatamMilesGroup';

import {
  showContactUs,
  showMyData,
  showMyPurchases,
  showMyTickets,
  showGiftcardBalance,
  showMyClubs,
  showMyPoints,
  showReturns,
  showExchangeLatamMiles,
} from '../../../../constants/Visible';

const Groups = [
  showMyPurchases === 'on' ? purchaseGroup : [],
  showContactUs === 'on' ? contactUsGroup : [],
  showReturns === 'on' ? returnsGroup : [],
  showMyTickets === 'on' ? ticketGroup() : [],
  showMyData === 'on' ? profileGroup : [],
  showMyPoints === 'on' ? pointsGroup : [],
  showGiftcardBalance === 'on' ? giftCardBalanceGroup : [],
  showMyClubs === 'on' ? clubsGroup : [],
  payCardGroup(),
  showExchangeLatamMiles === 'on' ? exchangeLatamMilesGroup : [],
];

export default Groups;
